import MyCard from '../../../components/MyCard/MyCard';
import MyTable from './MyTable';
import  endPoints from '../../../shared/endPoints/EndPoints.json'

export default function ContractTripsResults() {
    const endPoint = endPoints.BASEURL + endPoints.CONTRACT.CONTRACTTRIPS
    const columns = [
        {
            title: 'Έναρξη Διαδρομής',
            dataIndex: 'startDate',
            key: 'startDate',
        },
        {
            title: 'Λήξη Διαδρομής',
            dataIndex: 'endDate',
            key: 'endDate',
        },
        {
            title: 'Χιλιόμετρα',
            dataIndex: 'kilometers',
            key: 'kilometers',
        },
    ];

    return (<MyCard title="Διαδρομές"><MyTable endPoint={endPoint} columns={columns} size='small' /></MyCard >)
}

